import { IconProps } from 'types/icon.type'

// TODO: Replace icon with the open source one

export const VerticalDotsIcon = (props: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Vertical Dots icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5415 9.99992C8.5415 9.1945 9.19442 8.54158 9.99984 8.54158C10.8053 8.54158 11.4582 9.1945 11.4582 9.99992C11.4582 10.8053 10.8053 11.4583 9.99984 11.4583C9.19442 11.4583 8.5415 10.8053 8.5415 9.99992Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5415 4.16659C8.5415 3.36117 9.19442 2.70825 9.99984 2.70825C10.8053 2.70825 11.4582 3.36117 11.4582 4.16659C11.4582 4.972 10.8053 5.62492 9.99984 5.62492C9.19442 5.62492 8.5415 4.972 8.5415 4.16659Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5415 15.8333C8.5415 15.0278 9.19442 14.3749 9.99984 14.3749C10.8053 14.3749 11.4582 15.0278 11.4582 15.8333C11.4582 16.6387 10.8053 17.2916 9.99984 17.2916C9.19442 17.2916 8.5415 16.6387 8.5415 15.8333Z"
        fill="currentColor"
      />
    </svg>
  )
}
